






















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import moment from 'moment'

import config from '../config'
import { Change } from '../store/timeline'

interface Delta {
    [name: string]: any[2]
}

@Component({
})
export default class ChangelogDialog extends Vue {
    loading = false
    visible = true
    filterSubscribed = true
    totalChanges = 0
    changes: Change[] = []
    pagination: any = {}

    headers = [
        {
            text: 'Date',
            align: 'left',
            sortable: false,
            value: 'name',
        },
        {
            text: 'User',
            align: 'left',
            sortable: false,
            value: 'user',
        },
        {
            text: 'Brand',
            align: 'left',
            sortable: false,
            value: 'brand',
        },
        {
            text: 'Type',
            align: 'left',
            sortable: false,
            value: 'type',
        },
        {
            text: 'Title',
            align: 'left',
            sortable: false,
            value: 'title',
            width: '50%',
        },
        {
            text: 'Operation',
            align: 'left',
            sortable: false,
            value: 'operation',
        },
        {
            text: 'Changes',
            align: 'left',
            sortable: false,
            value: 'type',
            width: '50%',
        },
    ]

    @Watch('pagination', { deep: true })
    watchPagination() {
        this.reload()
    }

    @Watch('filterSubscribed')
    watchFilterSubscribed() {
        this.reload()
    }

    async mounted() {
        this.reload()
    }

    async reload() {
        this.loading = true
        try {
            const response = await this.$store.dispatch('api/get', {
                path: `change`,
                params: {
                    page: this.pagination.page,
                    page_size: this.pagination.rowsPerPage,
                    subscribed: this.filterSubscribed ? '1' : '0',
                },
            })
            this.totalChanges = response.data.count
            this.changes = response.data.results
        } finally {
            this.loading = false
        }
    }

    formatDate(value: Date) {
        return moment(value).format('YYYY-MM-DD HH:mm:SS')
    }

    formatLabel(key: string) {
        let s = key.replace('_', ' ')
        return s.substring(0, 1).toUpperCase() + s.substring(1)
    }

    formatValue(key: string, value: any) {
        if (key === 'medias') {
            return value.map((x: any) => x.image_url || x.video_url).join(', ')
        }
        if (Array.isArray(value)) {
            return value.join(', ')
        }
        return value
    }

    formatDelta(delta: Delta) {
        const a = []
        for (let k in delta) {
            a.push([this.formatLabel(k), delta[k].map((v: any) => this.formatValue(k, v))])
        }
        return a
    }

    close() {
        this.$router.push({ name: 'home' })
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChangelogDialog.vue